import translations from '../../translations/app-translations';

const TimeParse = {
    fromSeconds: (seconds) => {
        if (seconds <= 0) {
            return '';
        }

        const dateLeft = new Date(seconds * 1000).toISOString();
        if (seconds < 3600) {
            return dateLeft.substr(14, 5);
        }
        return dateLeft.substr(11, 8);
    },
    fromSecondsToText: (seconds, locale) => {
        let result = '';
        const minutes = Math.floor(seconds / 60);
        result = `${minutes} ${minutes > 1 ? translations[locale]['time-minute-plural'] : translations[locale]['time-minute-singular']}`;
        const secondsRest = seconds - minutes * 60;
        if (secondsRest > 0) {
            result += ` ${secondsRest} ${secondsRest > 1 ? translations[locale]['time-second-plural'] : translations[locale]['time-second-singular']}`;
        }
        return result;
    },
};

export default TimeParse;



/** WEBPACK FOOTER **
 ** ./src/services/time-parse.js
 **/